import { render, staticRenderFns } from "./RemoveCart.vue?vue&type=template&id=22159c40&"
import script from "./RemoveCart.vue?vue&type=script&lang=js&"
export * from "./RemoveCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports